module.exports = __webpack_public_path__ + "img/3ds.5fcb7cd4.svg";